import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getProfileById,
  getProfiles,
  getStaffByPersonnelIds,
  getManagedStaff,
  getStaffList,
  updateProfile,
} from "./staff";
import { staffQueryKeys } from "./query-keys";
import { normalizeProfileList } from "./transformers";

export function useGetProfiles() {
  return useQuery({
    queryKey: staffQueryKeys.profiles(),
    queryFn: getProfiles,
    select: normalizeProfileList,
  });
}

export function useGetProfileById(id, enabled = true) {
  return useQuery({
    queryKey: staffQueryKeys.detail(id),
    queryFn: () => getProfileById(id),
    enabled: enabled && !!id,
  });
}

export function useGetStaffList() {
  return useQuery({
    queryKey: staffQueryKeys.list(),
    queryFn: getStaffList,
  });
}

export function useGetStaffByPersonnelIds(personnelIds, enabled = true) {
  const hasIds = Array.isArray(personnelIds) && personnelIds.length > 0;

  return useQuery({
    queryKey: staffQueryKeys.byPersonnelIds(personnelIds),
    queryFn: () => getStaffByPersonnelIds(personnelIds),
    enabled: enabled && hasIds,
    select: normalizeProfileList,
  });
}

/** All direct reports (supervisor_id = me). Pass level only to filter. */
export function useGetManagedStaff(level = null, enabled = true) {
  return useQuery({
    queryKey: staffQueryKeys.managedStaff(level),
    queryFn: () => getManagedStaff(level),
    enabled,
    select: normalizeProfileList,
  });
}

export function useUpdateProfileMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }) => updateProfile(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: staffQueryKeys.all });
    },
  });
}
